import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  Input,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GRAY, VARIANT } from "../../../../constants/colors";
import { goToVendaDigitadaList } from "../../../../routes/coordinator";
import VendasDigitadasApi from "../../../../services/vendasDigitadasApi";
import {
  abrirWhatsApp,
  formatarTelefone,
  linkDePagamento,
  telefoneValido,
} from "../../../../constants/linkPagamento";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function ModalSendEmailRequest({
  isOpen,
  setIsOpen,
  token,
  permitirPix,
}: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();

  const colors = useRecoilState(customColors)[0];

  const onClose = () => {
    setIsOpen(false);
    goToVendaDigitadaList(navigate);
  };

  const [loading, setLoading] = useState(false);

  async function sendEmail() {
    try {
      setLoading(true);
      const response = await VendasDigitadasApi.senEmailWithLinkForPayment(
        token
      );
      setLoading(false);
      toast.success("Link enviado para o e-mail com sucesso!");
      goToVendaDigitadaList(navigate);
    } catch (error) {
      console.log("error: ", error);
      toast.error("Não foi possível enviar o e-mail de pagamento!");
    }
  }

  // Numero digitado na hora, so para montar a URL do wa.me — nao vai para o banco
  const [telefone, setTelefone] = useState("");

  function enviarWhatsApp() {
    if (!telefoneValido(telefone)) {
      toast.error("Informe o DDD e o número do WhatsApp.");
      return;
    }

    // linkDePagamento escolhe /pix ou /payment igual ao e-mail. Antes daqui o WhatsApp
    // mandava sempre /payment, o que abria a tela errada numa venda PIX.
    abrirWhatsApp(telefone, linkDePagamento({ token, permitirPix }));
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>Venda criada com sucesso!</Text>
            </Flex>
          </ModalHeader>
          <ModalBody display={"flex"} flexDir={"column"} alignItems={"center"}>
            <Text>
              Deseja enviar um e-mail com o link de pagamento para o cliente?
            </Text>

            <Flex w={"100%"} flexDir={"column"} mt={4}>
              <Text fontSize={"14px"} mb={1}>
                Ou envie o link pelo WhatsApp do pagador:
              </Text>
              <Flex w={"100%"} flexDir={"row"} gap={2}>
                <Input
                  placeholder="(00) 00000-0000"
                  value={telefone}
                  inputMode="numeric"
                  onChange={(e) => setTelefone(formatarTelefone(e.target.value))}
                />
                <Button
                  background={"#25D366"}
                  color={"white"}
                  minW={"fit-content"}
                  isDisabled={!telefoneValido(telefone)}
                  onClick={enviarWhatsApp}
                >
                  Enviar por WhatsApp
                </Button>
              </Flex>
            </Flex>
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
                        <Button
              background={VARIANT}
              color={"white"}
              mr={3}
              disabled={loading}
              onClick={() => {
                sendEmail();
                onClose();
              }}
            >
              {loading ? <Spinner /> : `Enviar E-mail`}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
